// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--Vq2Zj"};